import reducer from './dist/redux/reducers';

export default reducer;
export * from './dist/redux/reducers';
